/* eslint-disable */
import React from "react";
import { useCoreApp } from "./CoreAppContext";
import { Prediction } from "@utils/api/inference";
import type { Annotation } from "@/types/annotation";

// === LEGACY CONTEXT (thin wrapper) ===
export interface FlowContextType {
    // Expose whatever consumers expect – we just delegate to underlying hooks.
    selectedObject: string | null;
    previouslySelectedObject: string | null;
    setPreviouslySelectedObject: ReturnType<typeof useCoreApp>["setPreviouslySelectedObject"];
    task: ReturnType<typeof useCoreApp>["task"];
    setTask: ReturnType<typeof useCoreApp>["setTask"];
    reset: () => void;
    // plus hundreds more – to maintain compatibility we just spread providers.
    [key: string]: any;
    flowLocked: boolean;
    setFlowLocked: (flowLocked: boolean) => void;
    setCurrentFrameAnnotations: (
        annotations: Annotation[] | ((prev: Annotation[]) => Annotation[])
    ) => void;
    setCurrentFramePredictions: (
        predictions: Prediction[] | ((prev: Prediction[]) => Prediction[])
    ) => void;
    deleteAnnotationFromCurrentFrame: (annotationId: string) => void;
    deletePredictionFromCurrentFrame: (predictionId: string) => void;
}

export const FlowContext = React.createContext<FlowContextType | undefined>(undefined);

// === HOOKS ===
export function useFlow() {
    const ctx = React.useContext(FlowContext);
    if (!ctx) throw new Error("useFlow must be used within a FlowProvider");
    return ctx;
}
